import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ISpecificationProps } from "entity/specification/Specification";

const Specification = lazyLoadComponent(() => import("./Specification"));

export const RouteSpecification = (
    props: Omit<ISpecificationProps, "id" | "jobId" | "history" | "location" | "match"> & {
        stopClickPropagation?: boolean;
    },
) => {
    const { stopClickPropagation, ...specificationProps } = props;

    return (
        <RouteRelative
            path={routes.specification.details}
            render={(routeProps) => {
                const content = (
                    <BTSuspense>
                        <Specification
                            {...specificationProps}
                            {...routeProps}
                            id={parseInt(routeProps.match.params.id)}
                            jobId={parseInt(routeProps.match.params.jobId)}
                        />
                    </BTSuspense>
                );

                return stopClickPropagation ? (
                    <div onClick={(e) => e.stopPropagation()}>{content}</div>
                ) : (
                    content
                );
            }}
        />
    );
};
